import { createSlice } from "@reduxjs/toolkit";

export const commonSlice = createSlice({
  name: "commonReducer",
  initialState: {
    value: true,
  },
  reducers: {
    updateRedux: (state, data) => {
      state[data.payload.key] = data.payload.value;
    },
  },
});
export const { updateRedux } = commonSlice.actions;

export const value = (state) => state.commonReducer.value;

// LOADINGS
export const login_loading = (state) => state.commonReducer.login_loading;
// project data
export const project_data = (state ) => state.commonReducer.project_data;

export const all_employees = (state ) => state.commonReducer.all_employees;
// export const value = (state ) => state.commonReducer.value;
// export const value = (state ) => state.commonReducer.value;
// export const value = (state ) => state.commonReducer.value;
// export const value = (state ) => state.commonReducer.value;
// export const value = (state ) => state.commonReducer.value;

export default commonSlice.reducer;
